var React = require('react');

function ArrowCopy1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#7ED321","fillRule":"evenodd","d":"M8.136.932l7 8.5a.501.501 0 0 1-.386.818h-3.5v11.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-11.5H.75a.5.5 0 0 1-.386-.818l7-8.5a.502.502 0 0 1 .772 0"}));
}

ArrowCopy1.defaultProps = {"width":"16","height":"23","viewBox":"0 0 16 23"};

module.exports = ArrowCopy1;

ArrowCopy1.default = ArrowCopy1;



// WEBPACK FOOTER //
// ./src/Assets/Icons/arrow-copy-1.svg